import React from "react";
import { Outlet, useLocation } from "react-router";
import { Header } from "./Header";
import { MobileNavigation } from "./MobileNavigation";
import { useHeader } from "~/contexts/HeaderContext";
import { RouteTransition } from "~/components/transitions/PageTransition";

interface AppLayoutProps {
  children?: React.ReactNode;
}

export function AppLayout({ children }: AppLayoutProps) {
  const location = useLocation();

  const { headerConfig } = useHeader();

  // Check if current route is an auth page or onboarding
  const isAuthPage = location.pathname === '/signin' || 
                     location.pathname === '/register' || 
                     location.pathname === '/auth/callback';
                     
  const isOnboardingPage = location.pathname.startsWith('/onboarding');

  return (
    <div className={`flex min-h-screen flex-col ${!isAuthPage ? 'bg-background' : ''}`}>
      {/* Header - Hidden on auth pages only */}
      {!isAuthPage && !isOnboardingPage ? (
        <Header 
          title={headerConfig.title}
          icon={headerConfig.icon}
          showBackButton={headerConfig.showBackButton}
          onBackClick={headerConfig.onBackClick}
          showLogo={headerConfig.showLogo}
          rightContent={headerConfig.rightContent}
        />
      ) : <div className="h-12 sticky top-0 bg-background z-50" />}
      
      {/* Main Content Area with Transitions */}
      <main className={`flex-1 ${!isAuthPage && !isOnboardingPage ? 'pb-16' : ''}`}>
        <RouteTransition>
          {children || <Outlet />}
        </RouteTransition>
      </main>
      
      {/* Bottom Navigation - Hidden on auth pages and onboarding */}
      {!isAuthPage && !isOnboardingPage && <MobileNavigation />}
    </div>
  );
}

export default AppLayout;
